import React, { useEffect, useState } from 'react';
import { RecallsUnitedContent } from '../../pages/recalls-united/hooks/use-recalls-united-content';
import {
    RecallItems,
    RecallsApiResponse,
} from '../../../services/recalls-service/recalls-service';
import './recalls-list-desktop.scss';
import { ExemptWordsListProps } from '../../pages/recalls/hook/use-exempt-word-list';
import RecallsList from '../recalls-list/recalls-list';
import RecallReport from '../recall-report/recall-report';

interface Props {
    content: RecallsUnitedContent;
    recallsData: RecallsApiResponse | null | undefined;
    exemptWordsList?: ExemptWordsListProps | null;
    vin?: string | null;
    desktopOrLarger?: boolean;
    isWebview: boolean;
    showRecalls: boolean;
    showCsp: boolean;
    onClickScroll: () => void;
}

interface RecallReportInfo {
    recall: RecallItems;
    showModal: boolean;
    isCsp: boolean;
}

const RecallsListDesktop = (props: Props) => {
    const {
        content,
        recallsData,
        exemptWordsList,
        isWebview,
        showRecalls,
        showCsp,
        onClickScroll,
    } = props;
    const [areRecallsAndCsps, setAreRecallsAndCsps] = useState<boolean>(false);

    const [panel, setPanel] = useState<RecallReportInfo>({
        recall: {} as RecallItems,
        showModal: true,
        isCsp: false,
    });

    const handleShowRecall = (
        recall: RecallItems,
        showModal: boolean,
        isCsp: boolean
    ) => {
        setPanel({ recall, showModal: true, isCsp });
        onClickScroll();
    };

    useEffect(() => {
        const recallsAndCsps: RecallItems[] = [];
        recallsData?.nhtsa?.forEach(recall => recallsAndCsps.push(recall));
        recallsData?.recalls?.forEach(recall => recallsAndCsps.push(recall));

        recallsData?.fsa?.forEach(csp => recallsAndCsps.push(csp));
        setAreRecallsAndCsps(recallsAndCsps.length > 0);
        const initialRecall =
            recallsAndCsps.length > 0 ? recallsAndCsps[0] : ({} as RecallItems);

        const isInitialCsp: boolean =
            (recallsData?.recallsCount === undefined ||
                recallsData?.recallsCount <= 0) &&
            !!recallsData?.cspCount &&
            recallsData?.cspCount > 0;
        handleShowRecall(initialRecall, true, isInitialCsp);
    }, [recallsData]);
    return (
        <div className="recalls-buttons-list-desktop-container">
            <RecallsList
                content={content}
                recallsData={recallsData}
                handleShowRecall={handleShowRecall}
                exemptWordsList={exemptWordsList}
                currentRecall={panel.recall}
                showRecalls={showRecalls}
                showCsp={showCsp}
            />
            {areRecallsAndCsps && (
                <div className="recall-desktop-display-panel">
                    <RecallReport
                        recall={panel.recall}
                        content={content}
                        isCsp={panel.isCsp}
                        exemptWordsList={exemptWordsList}
                        vin={props.vin}
                        desktopOrLarger={props.desktopOrLarger}
                        isWebview={isWebview}
                    />
                </div>
            )}
        </div>
    );
};

export default RecallsListDesktop;
